export const FORM_PROXY_URL =
  import.meta.env.VITE_FORM_PROXY_URL || 'https://somatiq-form-proxy.somatiq.workers.dev';
